import React from 'react';

export const NotificationContext = React.createContext();
export const StripeContext = React.createContext();
export const WelcomeContext = React.createContext();
export const ModalContext = React.createContext();
export const AppLoadingContext = React.createContext();
